$(document).ready(function() {
  
  $('ul.As_Main_Image').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: 'ul.For_Main_Image'
  });
  $('ul.For_Main_Image').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: 'ul.As_Main_Image',
    dots: false,
    arrows: true,
    centerMode: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          centerMode: true
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true
        }
      }
    ]
  });

  var scrollTop = $(".scrollTop");
  $(".home-text-desc.home-btn a.btn").click(function() {
    $('html, body').animate({
      scrollTop: $("#purposemission-wc").offset().top
    }, 1500);
  });

  /*
  $(window).on('load resize', function(){
    $(".same-height").each(function () {
      $(".same-height").css("height", "auto");
      var e = -1;
      $(".same-height").each(function () {
        var t = $(this).outerHeight();
        console.log(t);
        e = t > e ? t : e
      }), $(".same-height").css("height", e)
    });
  });

  $(window).on('load resize', function(){
    $(".same-height-title").each(function () {
      $(".same-height-title").css("height", "auto");
      var e = -1;
      $(".same-height-title").each(function () {
        var t = $(this).outerHeight();
        console.log(t);
        e = t > e ? t : e
      }), $(".same-height-title").css("height", e)
    });
  });

  */
  
//   setTimeout(function(){  
//     $(".same-height").each(function () {
//       $(".same-height").css("height", "auto");
//       var e = -1;
//       $(".same-height").each(function () {
//         var t = $(this).outerHeight();
//         console.log(t);
//         e = t > e ? t : e
//       }), $(".same-height").css("height", e)
//     });
//     $(".same-height-title").each(function () {
//       $(".same-height-title").css("height", "auto");
//       var e = -1;
//       $(".same-height-title").each(function () {
//         var t = $(this).outerHeight();
//         console.log(t);
//         e = t > e ? t : e
//       }), $(".same-height-title").css("height", e)
//     });
//   }, 2000);
  
 
  
//   function matchheight_section() {
//     $(".same-height").each(function () {
//       $(".same-height").css("height", "auto");
//       var e = -1;
//       $(".same-height").each(function () {
//         var t = $(this).outerHeight();
//         console.log(t);
//         e = t > e ? t : e
//       }), $(".same-height").css("height", e)
//     });
//     $(".same-height-title").each(function () {
//       $(".same-height-title").css("height", "auto");
//       var e = -1;
//       $(".same-height-title").each(function () {
//         var t = $(this).outerHeight();
//         console.log(t);
//         e = t > e ? t : e
//       }), $(".same-height-title").css("height", e)
//     });
    
//     }
//   matchheight_section();
//   jQuery(window).on('load resize orientationchange', matchheight_section);


	
  $('.same-height').matchHeight();
  $('.same-height-title').matchHeight();
  
  var btn = $('#scroll_button');

  $(window).scroll(function() {
    if ($(window).scrollTop() > 300) {
      btn.addClass('show');
    } else {
      btn.removeClass('show');
    }
  });

  btn.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop:0}, '300');
  }); 
  if($(window).innerWidth() <= 1199){
    jQuery('.product-recommendations ul.grid').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  }
});
$(window).on('resize', function(){
  if($(window).innerWidth() <= 1199){
    if(!jQuery('.product-recommendations ul.grid').hasClass('slick-initialized')){
      jQuery('.product-recommendations ul.grid').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      });
    }
  }
  else{
    if(jQuery('.product-recommendations ul.grid').hasClass('slick-initialized')){
      setTimeout(function(){
        jQuery('.product-recommendations ul.grid').slick('unslick');
      },1000);
    }
    setTimeout(function(){
      $('.same-height').matchHeight();
      $('.same-height-title').matchHeight();
    },1000);
  }
})

/* custom add to cart - collection page - Start */

$(".custom-add-to-cart").on("click", function(){

  $(this).attr("disabled","disabled");

  var variantId = $(this).data("variant-id");
  var variantQuantity = 1,
      productType = $(this).data("product-type"),
      finalItemsString = {
        items:[
          {
            id:variantId,
            quantity:variantQuantity
          }
        ]
      };
  if(productType != ""){
    finalItemsString.items[0].properties = {
      _product_type:productType
    }
  }
      // finalItemsString = {"items": [{"id": '+ variantId + ',"quantity": ' + variantQuantity + '}]};
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    // data: JSON.parse(finalItemsString),
    data:finalItemsString,
    dataType: 'json', 
    success: function (data) {

      var productId = data.id;
      var notification = document.getElementById('cart-notification');
      var header = document.querySelector('sticky-header');
      
      notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  
      function openNoti() {
        notification.classList.add('animate', 'active');
        notification.addEventListener('transitionend', () => {
          notification.focus();
          trapFocus(notification);
        }, { once: true });
      }
      
      var parsedState = data.items[0];
      var prodDetails = "";
      var optionWithValues = parsedState.options_with_values;
      
      for( pitems in optionWithValues ){
        prodDetails = prodDetails + "<dt>" + optionWithValues[pitems].name + ": </dt><dd>" + optionWithValues[pitems].value + "</dd>"
      }
      
      var injectNotificationHtml = '<img style="max-width: 70px;" class="cart-notification-product__image" src="' + parsedState.featured_image.url + '" alt="' + parsedState.featured_image.alt + '" loading="lazy"> <div><p class="collection" style="background: unset;">' + parsedState.product_type + '</p><h3 class="cart-notification-product__name h4">' + parsedState.title + '</h3><dl><div class="product-option">' + prodDetails + '</div></dl></div></div>'
      document.getElementById("cart-notification-product").innerHTML = injectNotificationHtml;
      var cart_item;
      
      jQuery.getJSON('/cart.js', function(cart) {
        cart_item = cart.item_count
        $('#cart-notification-button').text('View my bag ('+cart_item+')');
      });

      /* Open Notification from top */
      openNoti();
      var cartContents = fetch('/cart.js').then(response => response.json()).then(data => {  $('#cart-icon-bubble').html('<span class="tooltiptext">Cart</span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="25" height="25" x="0" y="0" viewBox="0 0 32 32" style="enable-background:new 0 0 512 512" xml:space="preserve" class="tinton"><g><path xmlns="http://www.w3.org/2000/svg" d="m5.612 27.623a3.981 3.981 0 0 0 3.951 3.377h12.874a3.979 3.979 0 0 0 3.95-3.376l2.236-14.156a3 3 0 0 0 -2.964-3.468h-2.659v-2a7 7 0 0 0 -14 0v2h-2.659a3 3 0 0 0 -2.963 3.468zm5.388-19.623a5 5 0 0 1 10 0v2h-10zm-5.416 4.353a1 1 0 0 1 .757-.353h2.659v3a1 1 0 0 0 2 0v-3h10v3a1 1 0 0 0 2 0v-3h2.659a1 1 0 0 1 .988 1.156l-2.236 14.156a1.988 1.988 0 0 1 -1.974 1.688h-12.874a1.99 1.99 0 0 1 -1.975-1.688l-2.234-14.156a.992.992 0 0 1 .23-.803z" fill="#ffffff" data-original="#000000"></path></g></svg><span class="cart-count-bubble">'+data.item_count+' item</span><span>'+Shopify.formatMoney(data.total_price / 100, shop_currency)+'</span>');});

       /* to close the notification */
      $("body").on("click", function() {
        notification.classList.remove('active');
      })
    } 
  });

    $(this).removeAttr("disabled");
  
});

/* custom add to cart - c0ollection page - End */


// Update Bundle Product Tutle.... Start
const targetElement = document.querySelector('#th_pb_buildbox_id');
const observer = new MutationObserver(function(mutationsList) {
  for (let mutation of mutationsList) {
    if (mutation.target === targetElement || targetElement.contains(mutation.target)) {
      updateBundleItemstitme(mutation.target);
      break;
    }
  }
});
const config = { childList: true, subtree: true };
observer.observe(targetElement, config);
function updateBundleItemstitme(Wrapper) {
  Wrapper.querySelectorAll('.th_pb_cb_p_grid_title_text a').forEach((element) => {
    element.innerText = element.innerText.split('-')[0];
  });
}
// Update Bundle Product Tutle.... End